import React, { FC, useState } from 'react';
import { Alert, Container } from 'react-bootstrap';
import FacebookLogin from '../../components/authentication/FacebookLogin';
import GoogleLogin from '../../components/authentication/GoogleLogin';
import KreezeeLogin from '../../components/authentication/KreezeeLogin';
import LanguageSelect from '../../components/user/language/LanguageSelect';
import KreezeeCreateAccount from '../../components/authentication/KreezeeCreateAccount';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory, useParams } from 'react-router';

interface Props {
  isCreateAccount: boolean;
}

const LoginPage: FC<Props> = ({ isCreateAccount }) => {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { invitationId } = useParams<{ invitationId?: string | undefined }>();

  const history = useHistory();
  const intl = useIntl();

  return (
    <>
      <div className="background"></div>

      <div className="login-container">
        <div className="login-left-section">
          <div className="kreezee-logo-section">
            <img
              src="https://cache.kreezee.com/home/logos/flat_original_logo_kreezee_no_border.svg"
              alt="Kreezee Sports"
              className="kreezee-image"
            />
          </div>
          <div className="trophy-section">
            <img
              src="https://cache.kreezee.com/rocket/login/FRONT_OFFICE_CUP.png"
              alt="Trophy"
              className="trophy-image"
            />
          </div>
          <div className="tagline-section">
            <h2 className="tagline-primary">
              <FormattedMessage id="loginPage.fromRegistrationToCelebration" />
            </h2>
          </div>
        </div>

        <div className="login-right-section">
          <div className="kreezee-logo-section mobile-only">
            <img
              src="https://cache.kreezee.com/home/logos/flat_original_logo_kreezee_no_border.svg"
              alt="Kreezee Sports"
              className="kreezee-image"
            />
          </div>
          <Container className="kreezee-login-container">
            <div className="justify-content-end d-flex mb-3">
              <LanguageSelect />
            </div>

            {error && (
              <div className="position-relative mt-3 mb-3" style={{ display: 'block' }}>
                <Alert variant="danger" className="mb-0">
                  {error}
                </Alert>
              </div>
            )}

            <div className="login-title-section">
              <div className="title-wrapper">
                <h1 className="login-title">
                  Front-<span className="primary">Office</span>
                </h1>
              </div>
            </div>

            <div className="login-items">
              {!isCreateAccount && (
                <KreezeeLogin
                  setError={setError}
                  loading={loading}
                  setLoading={setLoading}
                  invitationId={invitationId}
                />
              )}
              {isCreateAccount && <KreezeeCreateAccount invitationId={invitationId} setError={setError} />}

              <div className="or-label">
                <FormattedMessage id="loginPage.or"></FormattedMessage>
              </div>
              <div className="login-providers">
                <FacebookLogin setError={setError} />
                <GoogleLogin setError={setError} />
              </div>

              <div className="mt-4">
                <a
                  className="account-link"
                  onClick={() =>
                    history.push(
                      isCreateAccount
                        ? `/login${invitationId ? `/${invitationId}` : ''}`
                        : `/create-account${invitationId ? `/${invitationId}` : ''}`,
                    )
                  }
                >
                  <span>
                    {isCreateAccount
                      ? intl.formatMessage({ id: 'loginPage.alreadyHaveAccount' })
                      : intl.formatMessage({ id: 'loginPage.noAccount' })}
                  </span>
                  <span className="action">
                    {isCreateAccount
                      ? intl.formatMessage({ id: 'loginPage.logIn' })
                      : intl.formatMessage({ id: 'loginPage.signUp' })}
                  </span>
                </a>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
